import Page from "../../page";
import BackButton from "../BackButton";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getCartDetails, getOrders } from "../../../redux/connectedComponent/orderAPI/orderAPI.slice";
import { getApis, getAsyncApis} from '../../../redux/connectedComponent/apiDirectory/apiDirectory.slice';
import OrderAPIStepper from "./Sub-components/OrderAPIStepper"
import {Loader} from 'cdk-radial'
import { PAGE_TITLE } from "../../../constants/constants";

const OrderAPIContainer = () => {

    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const {fortellisEnterpriseEntityId, authenticationToken:token,isDealerPurchaseDisabled } =
      state?.loginDetailsSlice;

    const fetchingCartDetails = state?.orderAPISlice?.fetchingCartDetails;
    const fetchingOrderDetails = state?.orderAPISlice?.fetchingOrderDetails;
  const orders = state?.orderAPISlice?.orders
    const {
      apis,
      restApisLoading,
      asyncApis,
      asyncApisLoading
    } = state.apiDirectorySlice;
  const [hasDispatchedFetch, setHasDispatchedFetch] = useState(false);  
    useEffect(()=>{
       
        if (apis && apis.length <= 0) {
            dispatch(getApis({ token,isDealerPurchaseDisabled }));
        }
        if (asyncApis && asyncApis.length <= 0) {
          dispatch(getAsyncApis({ token,isDealerPurchaseDisabled }));
        }
        if (fortellisEnterpriseEntityId) {
          dispatch(
            getCartDetails({ entityId: fortellisEnterpriseEntityId, token, isExpanded: true })
          );
      setHasDispatchedFetch(true);
        }
       if (orders && Object.keys(orders.app).length <=0 && fortellisEnterpriseEntityId) {
                 dispatch(getOrders({token, entityId: fortellisEnterpriseEntityId }))
               }
      },[fortellisEnterpriseEntityId, token])

    return (
      <Page pageHeader={PAGE_TITLE.INTEGRATIONS}>
        <div className="order-api-container-back-button-div">
        <BackButton />
        </div>
        <div
          className="orderapi-stepper"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#FAFAFA'
          }} 
        >
          {fetchingCartDetails || restApisLoading || asyncApisLoading || fetchingOrderDetails || !hasDispatchedFetch ? (
            <Loader
              label="fetching cart info..."
              className="order-api-loader"
            />
          ) : (
            <OrderAPIStepper />
          )}
        </div>
      </Page>
    );
}
export default OrderAPIContainer;